const state = {
    summaryIndicators: [],
    savingIndicator: false
}

const actions = {
    fetchSummaryIndicators (context, data) {
        axios.get('/api/summary-indicators', {params: data})
        .then( (response) => {
            context.commit("setSummaryIndicators", response.data)
        })
        .catch( (e) => {
            console.log("Error: summary.js, fetchSummaryIndicators(), "+ e.message)          
        })
    },
    saveSummaryIndicator (context, data) {
        if (context.state.savingIndicator) {
            return
        }

        context.state.savingIndicator = true

        axios.post('/api/summary-indicator', data)
        .then( (response) => {
            console.dir(response.data)
            context.commit("setSummaryIndicators", response.data)
        })
        .catch( (e) => {
            console.log("Error: summary.js, saveIndicator(), "+ e.message)          
        })
        .finally(() => {
            context.state.savingIndicator = false
        })
    }
}

const mutations = {
    setSummaryIndicators (state, data) {
        return state.summaryIndicators = data
    }
}

const getters = {
    //
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}